<template>
    <section>
        <div @click="linkTo('inicio')" class="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" stroke-linecap="round" />
            </svg>
            <p>Comunidad</p>

        </div>
        <hr class="mov">

        <div class="row">
            <div class="image"></div>
            <div class="cards">
                <div class="card" @click="toggleAdminChat()">
                    <div class="cardHeader">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                            <path
                                d="M6.5 0.500122C7.34615 0.500122 7.76923 1.11531 7.76923 2.34567C7.76923 2.89541 7.71795 3.53677 7.61539 4.26976L7.46154 5.2907C7.41026 5.73572 7.3718 6.01059 7.34615 6.11531L7.26923 6.62578L9.11539 5.13363C10.3205 4.13886 11.1923 3.64148 11.7308 3.64148C12.2692 3.64148 12.641 3.85091 12.8462 4.26976C12.9487 4.42682 13 4.61007 13 4.81949C13 5.39541 12.7051 5.86662 12.1154 6.23311C11.5513 6.57342 10.7821 6.92682 9.80769 7.29331L8.07692 8.00012L10.2308 8.864C11 9.17813 11.5641 9.453 11.9231 9.6886C12.641 10.0813 13 10.5787 13 11.1808C13 11.364 12.9103 11.6127 12.7308 11.9268C12.5769 12.2148 12.2436 12.3588 11.7308 12.3588C11.2179 12.3588 10.3462 11.8614 9.11539 10.8666L7.26923 9.37447L7.34615 9.96347C7.34615 10.0944 7.38462 10.3561 7.46154 10.7488L7.69231 12.1232C7.74359 12.6467 7.76923 13.1703 7.76923 13.6938C7.76923 14.1912 7.65385 14.6232 7.42308 14.9897C7.21795 15.33 6.91026 15.5001 6.5 15.5001C6.08974 15.5001 5.76923 15.33 5.53846 14.9897C5.33333 14.6232 5.23077 14.1781 5.23077 13.6546C5.23077 13.1048 5.28205 12.4635 5.38462 11.7305L5.53846 10.7095C5.58974 10.2645 5.6282 9.98965 5.65385 9.88494L5.73077 9.37447L3.88462 10.8666C2.67949 11.8614 1.80769 12.3588 1.26923 12.3588C0.730769 12.3588 0.358974 12.1493 0.153846 11.7305C0.0512821 11.5734 0 11.3902 0 11.1808C0 10.6048 0.282051 10.1467 0.846154 9.8064C1.4359 9.43991 2.21795 9.07342 3.19231 8.70693L4.92308 8.00012L2.76923 7.13625C2.02564 6.84829 1.44872 6.57342 1.03846 6.31164C0.346154 5.89279 0 5.39541 0 4.81949C0 4.63625 0.0769231 4.40065 0.230769 4.11269C0.410256 3.79855 0.692308 3.64148 1.07692 3.64148C1.48718 3.64148 1.89744 3.77237 2.30769 4.03415C2.71795 4.26975 3.24359 4.63625 3.88462 5.13363L5.73077 6.62578L5.65385 6.03677C5.65385 5.90588 5.61539 5.6441 5.53846 5.25143L5.30769 3.87709C5.25641 3.35353 5.23077 2.82996 5.23077 2.3064C5.23077 1.75667 5.33333 1.32473 5.53846 1.01059C5.76923 0.670279 6.08974 0.500122 6.5 0.500122Z"
                                fill="url(#paint0_linear_2967_4233)" />
                            <defs>
                                <linearGradient id="paint0_linear_2967_4233" x1="13" y1="8.00012" x2="0" y2="8.00012"
                                    gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#FFE711" />
                                    <stop offset="1" stop-color="#96FF11" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <h4>Chat Administradores</h4>
                        <specialButtonMicro class="pc" />
                    </div>
                    <p>Recibe asistencia personalizada sobre tu cuenta, pagos y soporte técnico. Estamos aquí para
                        ayudarte.</p>
                    <svg class="mov" xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16"
                        fill="none">
                        <path d="M1 15L6 8L1 1" stroke="#B359F8" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </div>
                <hr class="mov">
                <div class="card" @click="toggleChat()">
                    <div class="cardHeader">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                            <path
                                d="M6.5 0.500122C7.34615 0.500122 7.76923 1.11531 7.76923 2.34567C7.76923 2.89541 7.71795 3.53677 7.61539 4.26976L7.46154 5.2907C7.41026 5.73572 7.3718 6.01059 7.34615 6.11531L7.26923 6.62578L9.11539 5.13363C10.3205 4.13886 11.1923 3.64148 11.7308 3.64148C12.2692 3.64148 12.641 3.85091 12.8462 4.26976C12.9487 4.42682 13 4.61007 13 4.81949C13 5.39541 12.7051 5.86662 12.1154 6.23311C11.5513 6.57342 10.7821 6.92682 9.80769 7.29331L8.07692 8.00012L10.2308 8.864C11 9.17813 11.5641 9.453 11.9231 9.6886C12.641 10.0813 13 10.5787 13 11.1808C13 11.364 12.9103 11.6127 12.7308 11.9268C12.5769 12.2148 12.2436 12.3588 11.7308 12.3588C11.2179 12.3588 10.3462 11.8614 9.11539 10.8666L7.26923 9.37447L7.34615 9.96347C7.34615 10.0944 7.38462 10.3561 7.46154 10.7488L7.69231 12.1232C7.74359 12.6467 7.76923 13.1703 7.76923 13.6938C7.76923 14.1912 7.65385 14.6232 7.42308 14.9897C7.21795 15.33 6.91026 15.5001 6.5 15.5001C6.08974 15.5001 5.76923 15.33 5.53846 14.9897C5.33333 14.6232 5.23077 14.1781 5.23077 13.6546C5.23077 13.1048 5.28205 12.4635 5.38462 11.7305L5.53846 10.7095C5.58974 10.2645 5.6282 9.98965 5.65385 9.88494L5.73077 9.37447L3.88462 10.8666C2.67949 11.8614 1.80769 12.3588 1.26923 12.3588C0.730769 12.3588 0.358974 12.1493 0.153846 11.7305C0.0512821 11.5734 0 11.3902 0 11.1808C0 10.6048 0.282051 10.1467 0.846154 9.8064C1.4359 9.43991 2.21795 9.07342 3.19231 8.70693L4.92308 8.00012L2.76923 7.13625C2.02564 6.84829 1.44872 6.57342 1.03846 6.31164C0.346154 5.89279 0 5.39541 0 4.81949C0 4.63625 0.0769231 4.40065 0.230769 4.11269C0.410256 3.79855 0.692308 3.64148 1.07692 3.64148C1.48718 3.64148 1.89744 3.77237 2.30769 4.03415C2.71795 4.26975 3.24359 4.63625 3.88462 5.13363L5.73077 6.62578L5.65385 6.03677C5.65385 5.90588 5.61539 5.6441 5.53846 5.25143L5.30769 3.87709C5.25641 3.35353 5.23077 2.82996 5.23077 2.3064C5.23077 1.75667 5.33333 1.32473 5.53846 1.01059C5.76923 0.670279 6.08974 0.500122 6.5 0.500122Z"
                                fill="url(#paint0_linear_2967_4233)" />
                            <defs>
                                <linearGradient id="paint0_linear_2967_4233" x1="13" y1="8.00012" x2="0" y2="8.00012"
                                    gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#FFE711" />
                                    <stop offset="1" stop-color="#96FF11" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <h4>Chat Comunidad</h4>
                        <specialButtonMicro class="pc" />
                    </div>

                    <p>Conecta con otros usuarios, comparte tips, logros y experiencias de tus entrenamientos.
                    </p>
                    <svg class="mov" xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16"
                        fill="none">
                        <path d="M1 15L6 8L1 1" stroke="#B359F8" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </div>
            </div>
        </div>
        <programas class="pc" />
        <programasMobile class="mov" />
        <chatComunity :visible="isChatVisible" @update:visible="isChatVisible = $event" />
        <chatAdmins :visibleAdmin="isChatAdminsVisible" @update:visibleAdmin="isChatAdminsVisible = $event" />
    </section>
</template>

<script>
import programas from '../home/programas.vue';
import specialButtonMicro from '../specialButtonMicro.vue';
import chatComunity from './chatComunity.vue';
import chatAdmins from './chatAdmins.vue';
import programasMobile from "../home/programasMobile.vue";

export default {
    name: 'Comunidad',
    data() {
        return {
            isChatVisible: false,
            isChatAdminsVisible: false
        };
    },
    methods: {
        linkTo(enlace) {
            const query = enlace;
            if (query) {
                const currentQuery = this.$route.query.a;

                // Verifica si la búsqueda actual es la misma que la nueva búsqueda
                if (query !== currentQuery) {
                    this.$router.push({ path: '/web-app', query: { a: query } });
                    document.getElementById('up').scrollIntoView();

                } else {
                    console.log('Ya te encuentras en este enlace');
                }
            } else {
                console.log('No se recibio link');
            }
        },
        toggleChat() {
            this.isChatVisible = !this.isChatVisible;
        },
        toggleAdminChat() {
            this.isChatAdminsVisible = !this.isChatAdminsVisible;
        },
    },
    components: {
        specialButtonMicro,
        chatComunity,
        chatAdmins,
        programas,
        programasMobile,
    },
};
</script>

<style scoped>
section {
    padding: 0 !important;

}

.goBack {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 1.041667vw;
    cursor: pointer;
    width: fit-content;
}

.goBack svg {
    width: .620069vw;
    height: 1.736111vw;
    flex-shrink: 0;
}

.goBack p {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.row {
    display: flex;
    gap: 2.083333vw;
    height: 20.972222vw;
}

.image {
    width: 70.347222vw;
    height: auto;
    background-image: url(../../assets/SlidePrincipalComunidad.png);
    background-repeat: no-repeat;
    background-size: cover;
}

.row .cards {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 23.194444vw;
}

.card {
    display: flex;
    padding: 1.388889vw;
    flex-direction: column;
    align-items: flex-start;
    gap: .555556vw;
    align-self: stretch;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    cursor: pointer;
}

.card>p {
    color: var(--Text, #464D5B);

    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.cardHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self: stretch;
    align-items: center;
}

.cardHeader svg {
    width: .902778vw;
    height: 1.041667vw;
}

.cardHeader h4 {
    color: var(--Text, #464D5B);

    font-family: Manrope;
    font-size: 1.388889vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 75%;
}

.mov {
    display: none !important;
}

@media (max-width: 530px) {
    .pc {
        display: none;
    }

    .mov {
        display: flex !important;
    }

    .goBack {
        width: 100%;
    }

    .goBack p {
        width: 100%;
        text-align: center;

        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 4.186047vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .goBack svg {
        width: 3.255814vw;
        height: 3.255814vw;
    }

    section {
        gap: 4.651163vw !important;
    }

    hr {
        display: block;
        background-color: #E3E3E9;
        border: 0;
        height: .232558vw;
    }

    .image {
        width: auto;
        height: 64.186047vw;
        background-position: center;
        background-image: url(../../assets/SlidePrincipalComunidadMov.png);
    }

    .row {
        flex-direction: column;
        gap: 4.651163vw;
        height: auto;
    }

    .row .cards {
        width: 100%;
        gap: 4.651163vw;
    }

    .card {
        padding: 0;
        border-radius: 0;
        border: 0;
        gap: 4.651163vw;
        position: relative;
    }

    .cardHeader svg {
        display: none;
    }

    .cardHeader h4 {
        padding: 2.325581vw 4.651163vw;
        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 3.488372vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 100%;
        border-radius: 11.627907vw;
        border: solid .232558vw #464D5B;
    }

    .card>p {
        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 2.790698vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .card>svg {
        position: absolute;
        right: 3.953488vw;
        top: 3.023256vw;
        width: 2.093023vw;
        height: 3.953488vw;
    }
}
</style>